import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=ea16fde8"
import script from "./header-bar.vue?vue&type=script&lang=js"
export * from "./header-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea16fde8')) {
      api.createRecord('ea16fde8', component.options)
    } else {
      api.reload('ea16fde8', component.options)
    }
    module.hot.accept("./header-bar.vue?vue&type=template&id=ea16fde8", function () {
      api.rerender('ea16fde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/header-bar/header-bar.vue"
export default component.exports